import { useMemo } from "react";
import { useAccessToken } from "shared-ts-utils-authentication";
import { useCustomerEnvironmentName } from "firefly-shared-ts-customer-environment";
import { _throw, NullError } from "shared-ts-utils-core";
import { SweepingDao } from "./SweepingDao";

export const useSweepingDao = (): SweepingDao => {
  const accessToken = useAccessToken();
  const customerEnvironment =
    useCustomerEnvironmentName() ??
    _throw(new NullError("customerEnvironment"));
  return useMemo(
    () =>
      new SweepingDao({
        accessToken: accessToken,
        customerEnvironment: customerEnvironment,
      }),
    [accessToken, customerEnvironment]
  );
};
